import { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { itemServices } from "../../APIServices/PasswordManagement/itemServices";
import Swal from "sweetalert2";

const MoveItem = ({
  Show,
  Hide,
  Title,
  getSingleItem,
  itemData,
  getItemList,
  setItemData,
  setItemId,
  activeItem,
  isDark,
  groupList,
  auth
}) => {
  const [groupId, setGroupId] = useState("");
  const [loader, setLoader] = useState(false);

  const updatedItem = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Move Item?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, move it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        setLoader(true);
        userData.itemId = itemData?.itemId;
        userData.categoryId = itemData?.categoryId;
        userData.groupId = groupId;
        let data = await itemServices.updatedItem(auth, userData);
        if (data?.statusCode === 200) {
          getItemList();
          getSingleItem(itemData?.itemId);
          if (!(activeItem === "all" || activeItem === "bookmark")) {
            setItemData("");
            setItemId("")
          }
          Hide();
        }
        setLoader(false);
      }
    });
  };

  useEffect(() => {
    if (itemData) {
      setGroupId(itemData?.groupId)
    }
  }, [itemData]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}>
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Group{" "}
            <abbr className="text-danger" title="Require">
              *
            </abbr>
          </Form.Label>
          <Form.Select
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            onChange={(e) => {
              setGroupId(e.target.value)
            }}
            value={groupId}
          >
            <option value="">Select Group</option>
            <option value="personal">Personal</option>
            {groupList?.map((item, index) => (
              <option key={index} value={item?.groupId}>
                {item?.groupName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Offcanvas.Body>

      <div className={`${isDark ? "bg-dark" : "bg-light"} p-2 border-top text-end`}>
        <Button
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-1 py-1 px-3"
          title={Title}
          // disabled={!groupId || loader}
          onClick={updatedItem}
        >
          Move Item
        </Button>
      </div>
    </Offcanvas>
  );
};

export default MoveItem;
